import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import { Simulate } from "react-dom/test-utils";
var error = Simulate.error;
import InternalServerError500Exception from "@/exceptions/InternalServerError500Exception";
export var api__checkFinanceEligibility = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
    var apiUrl, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiUrl = "/finance/eligibility-check";
          _context.prev = 1;
          _context.next = 4;
          return fetcher().post(apiUrl, data);
        case 4:
          res = _context.sent;
          return _context.abrupt("return", res.data.data);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", error(_context.t0.message));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function api__checkFinanceEligibility(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getProductDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(product_id) {
    var data, requestData, axiosConfig;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          data = {
            filters: {
              post_id: product_id
            }
          };
          requestData = {
            search_data: JSON.stringify(data || {})
          };
          axiosConfig = {
            params: requestData
          };
          return _context3.abrupt("return", fetcher(null).get("/search/index", axiosConfig).then(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res) {
              var _res$data, _res$data2, _res$data2$data;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) !== 200)) {
                      _context2.next = 2;
                      break;
                    }
                    throw new InternalServerError500Exception("api__doSearch", {
                      url: "search/index",
                      data: axiosConfig.params
                    });
                  case 2:
                    return _context2.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.products) || {});
                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function api__getProductDetails(_x2) {
    return _ref2.apply(this, arguments);
  };
}();